import { createContext, useContext } from 'react';
import { useIsClient } from '@/hooks/useIsClient';

/**
 * When the server rendered the document (ms since the epoch), from the root
 * loader (@/seo/documentHead); null without one (the SPA, tests).
 */
export const RenderTimeContext = createContext<number | null>(null);

/**
 * "Now" for what a render decides from the clock (a promotion's or a sale's
 * phase, a countdown): the server's render time on the server and while the
 * browser hydrates that HTML, so both trees agree whenever the HTML was made
 * (it can be minutes old in a shared cache); the real time in every other
 * render. Without a server render time (the SPA, an in-app navigation) it is
 * always the real time.
 */
export function useRenderNow(): Date {
  const renderedAt = useContext(RenderTimeContext);
  const isClient = useIsClient();
  return !isClient && renderedAt !== null ? new Date(renderedAt) : new Date();
}

export default useRenderNow;
